import { render, staticRenderFns } from "./NewsStatusChip.vue?vue&type=template&id=09980ac4&scoped=true&"
import script from "./NewsStatusChip.vue?vue&type=script&lang=js&"
export * from "./NewsStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09980ac4",
  null
  
)

export default component.exports